import { create } from "zustand";
import { persist } from "zustand/middleware";

const API_URL = process.env.REACT_APP_API_URL || "https://rvtk.edu.kz/api/";

// --- НОВЫЙ chatStore с поддержкой НЕСКОЛЬКИХ чатов ---
export const useChatStore = create(
  persist(
    (set, get) => ({
      // Структура: { "chat-id-1": { id: "...", title: "...", messages: [] }, ... }
      chats: {},
      activeChatId: null, // ID текущего открытого чата
      isLoading: false,

      // --- Функция: Создать новый пустой чат ---
      createNewChat: () => {
        set({ activeChatId: null }); // Сбрасываем ID, 'sendMessage' создаст новый
      },

      // --- Функция: Выбрать чат из истории ---
      selectChat: chatId => {
        set({ activeChatId: chatId });
      },

      // --- Функция: Удалить чат ---
      deleteChat: chatId => {
        set(state => {
          const newChats = { ...state.chats };
          delete newChats[chatId];
          return {
            chats: newChats,
            // Если удалили активный чат, сбрасываем
            activeChatId:
              state.activeChatId === chatId ? null : state.activeChatId,
          };
        });
      },

      // --- ГЛАВНАЯ ФУНКЦИЯ ОТПРАВКИ СООБЩЕНИЯ ---
      sendMessage: async (query, file = null) => {
        set({ isLoading: true });
        const state = get();
        let chatId = state.activeChatId;
        let isNewChat = false;

        // 1. Если это новый чат (activeChatId === null)
        if (chatId === null) {
          isNewChat = true;
          chatId = "chat-" + Date.now(); // Генерируем новый ID

          // --- Автоматическое название чата ---
          // Берем первые 30 символов запроса
          const newTitle =
            query.length > 30 ? query.substring(0, 30) + "..." : query;

          // Создаем запись о новом чате
          set(state => ({
            chats: {
              ...state.chats,
              [chatId]: { id: chatId, title: newTitle, messages: [] },
            },
            activeChatId: chatId, // Делаем его активным
          }));
        }

        // 2. Добавляем сообщение пользователя в чат
        const userMessage = {
          role: "user",
          text: query,
          image: file ? URL.createObjectURL(file) : undefined,
        };

        // Добавляем сообщение и пустое сообщение-заглушку для ИИ
        set(state => ({
          chats: {
            ...state.chats,
            [chatId]: {
              ...state.chats[chatId],
              messages: [
                ...state.chats[chatId].messages,
                userMessage,
                { role: "model", text: "" }, // Заглушка для стриминга
              ],
            },
          },
        }));

        // 3. Готовим FormData для бэкенда
        const formData = new FormData();
        formData.append("query", query);
        formData.append("language", "ru"); // TODO: Сделать язык динамическим
        if (file) {
          formData.append("image", file);
        }

        try {
          // 4. Используем FETCH для стриминга (SSE)
          const response = await fetch(`${API_URL}ai/chat`, {
            method: "POST",
            body: formData,
            // БЕЗ 'Authorization' хедера - это публичный API
          });

          if (!response.ok) {
            throw new Error(`Ошибка сети: ${response.statusText}`);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder("utf-8");

          // 5. Читаем поток
          function readStream() {
            reader.read().then(({ done, value }) => {
              if (done) {
                // Поток завершен
                set({ isLoading: false });
                return;
              }

              const chunk = decoder.decode(value, { stream: true });
              const lines = chunk.split("\n\n");

              lines.forEach(line => {
                if (line.startsWith("data: ")) {
                  const dataStr = line.substring(6);
                  try {
                    const data = JSON.parse(dataStr);
                    if (data.token) {
                      // --- ОБНОВЛЯЕМ ПОСЛЕДНЕЕ СООБЩЕНИЕ В НУЖНОМ ЧАТЕ ---
                      set(state => {
                        const currentChat = state.chats[chatId];
                        const lastMessage =
                          currentChat.messages[currentChat.messages.length - 1];

                        if (lastMessage.role === "model") {
                          lastMessage.text += data.token;
                        }

                        return {
                          chats: {
                            ...state.chats,
                            [chatId]: {
                              ...currentChat,
                              messages: [...currentChat.messages],
                            },
                          },
                        };
                      });
                    }
                  } catch (e) {}
                }
              });

              readStream(); // Читаем следующий "кусочек"
            });
          }

          readStream(); // Запускаем чтение
        } catch (error) {
          console.error("Chat streaming failed:", error);
          // В случае ошибки, заменяем последнее сообщение на ошибку
          set(state => {
            const currentChat = state.chats[chatId];
            const lastMessage =
              currentChat.messages[currentChat.messages.length - 1];
            if (lastMessage.role === "model") {
              lastMessage.text = "Произошла ошибка при получении ответа.";
            }
            return {
              chats: {
                ...state.chats,
                [chatId]: {
                  ...currentChat,
                  messages: [...currentChat.messages],
                },
              },
              isLoading: false,
            };
          });
        }
      },
    }),
    {
      name: "ai-chat-storage", // Имя для localStorage
    },
  ),
);

